
<div class="row">

    <div class="col-lg-4 col-sm-12 mb-sm-4 mb-2">
        <div class="card border-1">

            <div class="card-body">
                <div class="card-title">Description:</div>
                <input type="text" [(ngModel)]="isf.description" [maxlength]="50" class="form-control form-control-sm" placeholder="Description of cargo"/>
            </div>

            <div class="card-body">
                <div class="card-title">Unlading Port</div>
                <input type="text" class="form-control form-control-sm" placeholder="Search Ports.."
                       [(ngModel)]="isf.unladingPort"
                       [value]="selectedUnladingPort.portCode"
                       [innerHTML]="selectedUnladingPort.portCode"
                       (change)="dataChange($event)"
                       (keydown)="dataChange($event)"
                       (focusout)="cleanPortSearch($event)"
                       [ngbTypeahead]="searchPorts"
                       [resultTemplate]="portsTemplate"
                       (selectItem)="unladingPortSelected($event)"
                />
            </div>

        </div>
    </div>

    <div class="col-lg-4 col-sm-12 mb-sm-4 mb-2">
        <div class="card border-1">

            <div class="card-body">
                <div class="card-title">ETD:</div>
                <input type="date" [(ngModel)]="isf.etd" (change)="etdChange($event)" (keydown)="dataChange($event)" title="ETD is a guesstimation" class="form-control form-control-sm"/>
            </div>

            <div class="card-body">
                <div class="card-title">ETA:</div>
                <input type="date" [(ngModel)]="isf.eta" (change)="dataChange($event)" (keydown)="dataChange($event)" title="ETA is a guesstimation" class="form-control form-control-sm"/>
            </div>

        </div>
    </div>

    <div class="col-lg-4 col-sm-12 mb-sm-4 mb-2">
        <div class="card border-1">
            <div class="card-body">
                <div class="card-title">Export Country</div>
                <select [(ngModel)]="isf.exportCountry"  (change)="dataChange($event)" class="form-control-sm form-control">
                    <option *ngFor="let c of htsCountries" [value]="c.co">[{{c.co}}] {{c.name}}</option>
                </select>
            </div>

            <div class="card-body">
                <div class="card-title">Origin Country</div>
                <select [(ngModel)]="isf.originCountry"  (change)="dataChange($event)" class="form-control-sm form-control">
                    <option *ngFor="let c of htsCountries" [value]="c.co">[{{c.co}}] {{c.name}}</option>
                </select>
            </div>
        </div>

    </div>
</div>

<ng-template #rt let-r="result" let-t="term">
    <span>{{r.name}}</span>
</ng-template>

<ng-template #portsTemplate let-r="result" let-t="term">
    <span class="badge badge-secondary">{{r.portCode}}</span>&nbsp;
    <span>{{r.name}}</span>
</ng-template>

<ng-template #foreignPortsTemplate let-r="result" let-t="term">
    <span class="badge badge-secondary">{{r.portCode}} : {{r.country}}</span>&nbsp;
    <span>{{r.portName}}</span>
</ng-template>
